import UserCard from './UserCard-redux';

export default UserCard;
